export default __webpack_public_path__ + "static/media/push-pin 3.34008b84.svg";